import { spaceMixin, spacingMixin } from '@zillow/constellation';
import { css } from 'styled-components';

const getBackgroundColor = ({ highlight, theme }) => {
  switch (highlight) {
    case 'blue':
      return `background-color: ${theme.ns().colors.blue100};`;
    case 'gray':
    default:
      return `background-color: ${theme.ns().colors.gray200};`;
  }
};

export default ({ theme }) =>
  theme &&
  theme.ns &&
  css`
    ${getBackgroundColor}
    padding: ${spaceMixin('sm')};
    ${spacingMixin};
  `;
